import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

// ── Editor visual (só ativo no localhost) ────────────────────────────────────
if (window.location.hostname === 'localhost') {
  window.addEventListener('message', (e) => {
    if (!e.data || typeof e.data !== 'object') return;

    if (e.data.type === 'EDITOR_HIGHLIGHT') {
      document.querySelectorAll('[data-editor-active]').forEach(el => el.removeAttribute('data-editor-active'));
      if (e.data.key) {
        const el = document.querySelector(`[data-editor-key="${e.data.key}"]`);
        if (el) { el.setAttribute('data-editor-active', '1'); el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      }
    }

    if (e.data.type === 'EDITOR_INJECT_STYLES') {
      let s = document.getElementById('__editor_styles__');
      if (!s) { s = document.createElement('style'); s.id = '__editor_styles__'; document.head.appendChild(s); }
      s.textContent = e.data.css;
    }
  });
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};
import { Toaster } from 'sonner';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';
import Home from './pages/Home';
import Sobre from './pages/Sobre';
import Consultas from './pages/Consultas';
import Contato from './pages/Contato';
import Admin from './pages/Admin';
import AdminAluno from './pages/AdminAluno';
import Login from './pages/Login';
import Area from './pages/Area';
import ProtectedRoute from './components/ProtectedRoute';
import TrocarSenha from './pages/TrocarSenha';
import AdminConteudos from './pages/AdminConteudos';
import AdminDespensa from './pages/AdminDespensa';
import AdminBiblioteca from './pages/AdminBiblioteca';
import AdminDietaTemplates from './pages/AdminDietaTemplates';
import AdminEmails from './pages/AdminEmails';
import AdminPresenca from './pages/AdminPresenca';
import PreviewArea from './pages/PreviewArea';
import './App.css';

// Redireciona subdomínio admin.* para /admin
const SubdomainRedirect = () => {
  const navigate = useNavigate();
  useEffect(() => {
    if (window.location.hostname.startsWith('admin.') && window.location.pathname === '/') {
      navigate('/admin', { replace: true });
    }
  }, [navigate]);
  return null;
};

const isAdmin = window.location.hostname.startsWith('admin.');
const isApp   = window.location.hostname.startsWith('app.');

function AppRoutes() {
  return (
    <>
        <ScrollToTop />
        <SubdomainRedirect />
        <div className="App min-h-screen bg-[#0A0A0A] text-[#F5F5F5] noise-texture">
          {!isAdmin && !isApp && <Navigation />}
          <Routes>
            <Route path="/" element={isApp ? <Navigate to="/login" replace /> : <Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/consultas" element={<Consultas />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/alunos/:id" element={<AdminAluno />} />
            <Route path="/admin/conteudos" element={<AdminConteudos />} />
            <Route path="/admin/despensa" element={<AdminDespensa />} />
            <Route path="/admin/biblioteca" element={<AdminBiblioteca />} />
            <Route path="/admin/dieta-templates" element={<AdminDietaTemplates />} />
            <Route path="/admin/emails" element={<AdminEmails />} />
            <Route path="/admin/presenca" element={<AdminPresenca />} />
            <Route path="/preview/:id" element={<PreviewArea />} />
            <Route path="/login" element={<Login />} />
            <Route path="/area" element={<ProtectedRoute><Area /></ProtectedRoute>} />
            <Route path="/trocar-senha" element={<ProtectedRoute><TrocarSenha /></ProtectedRoute>} />
            {/* Páginas desativadas — redirecionam para home */}
            <Route path="/resultados" element={<Navigate to="/" replace />} />
            <Route path="/blog" element={<Navigate to="/" replace />} />
            <Route path="/blog/:slug" element={<Navigate to="/" replace />} />
            <Route path="/agendamento" element={<Navigate to="/" replace />} />
          </Routes>
          {!isAdmin && !isApp && <Footer />}
          {!isAdmin && !isApp && <ChatBot />}
          <Toaster
            position="top-right"
            theme="dark"
            richColors
            toastOptions={{
              style: {
                background: '#121212',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                color: '#F5F5F5',
              },
            }}
          />
        </div>
      </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
export { AppRoutes };
